import { RotaCidade } from "../types/rota_cidade";

export const novaRotaCidade = (): RotaCidade => {
  return {
    cidade_id: "",
    rota_id: "",
  };
};
